import { AbstractControl } from '@angular/forms'

/**
 * Validates a full name string based on a regex
 * @param control Abstract control
 * @returns error or null
 */
export function FullnameValidator(control: AbstractControl) {
  if (!control.value) return null
  if (formatError(control.value)) {
    return {
      twoLetters: 'Your name should have at least two letters and no numbers.'
    }
  }
  if (twoWordsError(control.value)) {
    return { twoNames: 'Please provide your full name.' }
  }
  return null
}

function formatError(value: string) {
  const onlyLettersRegex = /[^\u0621-\u064A\u066E-\u06D5a-zA-Zà-žÀ-Ž\s\.]/g

  if (onlyLettersRegex.test(value)) return true

  const words = value.split(' ')
  for (const word of words) {
    if (word.length < 2) return true
  }

  return false
}
function twoWordsError(value: string) {
  const twoWordsRegex = /([\u0621-\u064A\u066E-\u06D5a-zA-Zà-žÀ-Ž\.]{2,}\s)*([\u0621-\u064A\u066E-\u06D5a-zA-Zà-žÀ-Ž]{2,}\s)+[\u0621-\u064A\u066E-\u06D5a-zA-Zà-žÀ-Ž]{2,}/g
  return value.replace(twoWordsRegex, '$') != '$'
}
